import { render, staticRenderFns } from "./PorOrgaoAtoInfralegal.vue?vue&type=template&id=2aeaa1c0&scoped=true"
import script from "./PorOrgaoAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./PorOrgaoAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./PorOrgaoAtoInfralegal.vue?vue&type=style&index=0&id=2aeaa1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeaa1c0",
  null
  
)

export default component.exports